import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCollection } from "../lib/api";
import { ProductCard, ProductCardSkeleton } from "../components/ProductCard";
import QuickView from "../components/QuickView";

export const CollectionPage = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [quick, setQuick] = useState(null);
  const bigSale = handle === "big-sales";

  useEffect(() => {
    let active = true;
    setData(null);
    getCollection(bigSale ? "trending-deals" : handle, 100)
      .then((d) => {
        if (!active) return;
        // Duplicate collection → redirect to its canonical URL (protects SEO/navigation).
        if (d.canonical_handle && d.canonical_handle !== handle) {
          navigate(`/collection/${d.canonical_handle}`, { replace: true });
          return;
        }
        let items = d.products || [];
        if (bigSale) items = items.filter((p) => p.onSale);
        setData({ ...d, products: items });
      })
      .catch(() => { if (active) setData({ products: [] }); });
    return () => { active = false; };
  }, [handle]);

  const title = bigSale ? "Big Sales" : (data?.title || handle);

  return (
    <div className="px-4 md:px-8 lg:px-12 mx-auto max-w-7xl py-8" data-testid="collection-page">
      <h1 className="text-3xl sm:text-4xl font-black tracking-tighter font-display capitalize">{title}</h1>
      {data?.description && <p className="text-muted-foreground mt-2 max-w-3xl text-sm">{data.description}</p>}
      <div className="mt-8">
        {data === null ? (
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">{["s1","s2","s3","s4","s5","s6","s7","s8"].map((k) => <ProductCardSkeleton key={k} />)}</div>
        ) : data.products.length === 0 ? (
          <div className="border border-dashed border-black/15 py-24 text-center"><p className="text-xl font-display font-bold">Coming Soon</p><p className="text-sm text-muted-foreground mt-1">New products for this collection are on their way.</p></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {data.products.map((p) => <ProductCard key={p.id} product={p} onQuickView={setQuick} />)}
          </div>
        )}
      </div>
      {quick && <QuickView product={quick} onClose={() => setQuick(null)} />}
    </div>
  );
};

export default CollectionPage;
